const CurrencyType = {
  USD: 1,
  EUR: 2,
};
// eslint-disable-next-line import/prefer-default-export
export { CurrencyType };
